"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _UserService = _interopRequireDefault(require("./services/UserService"));

var _index = _interopRequireDefault(require("../Button/index"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _Quiz = _interopRequireDefault(require("./Quiz.scss"));

var _QuizSubjects = _interopRequireDefault(require("./QuizSubjects.scss"));

var _QuizStrings = require("./QuizStrings");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _DataStoreComponent2 = _interopRequireDefault(require("../../../common/components/DataStoreComponent/DataStoreComponent2"));

var _QDGroupService = require("../../../KESI2/Services/QDGroupService");

var _Constants = require("../../constants/Constants");

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _QuizRoundOverviewStyle = require("./styles/QuizRoundOverviewStyle");

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _GameService = _interopRequireDefault(require("./services/GameService"));

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var QuizSubjects = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizSubjects, _DataStoreComponent);

  var _super = _createSuper(QuizSubjects);

  function QuizSubjects(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, QuizSubjects);
    _this = _super.call(this, props);
    _this.state = {};
    _this.waitingTimeout = null;
    _this.waitingDialogCloseFn = null;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizSubjects.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_GAME, _DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT, _DataStore.DATA_STORE_PATHS.QD_SUBJECTS, _DataStore.DATA_STORE_PATHS.QD_NETWORK_STATUS, _DataStore.DATA_STORE_PATHS.QD_LEARNING_STATE, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_GROUP_ID]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizSubjects.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'categoryinfos', 'quiz']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(QuizSubjects, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.setTitle((0, _QuizStrings.getString)('SUBJECTS'));

      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID, null);
    }
  }, {
    key: "setSubject",
    value: function () {
      var _setSubject = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(subject) {
        var feature, userAuth, user, groupUsers, storedImages, groupUsersWithImage, loadedUser, opponents, allGamesUnfiltered, allGame, historyBasedFeedback, completedGameIds, expiredGameIds;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _EquizzerActions["default"].setSubjectId(subject.id);

                _EquizzerActions["default"].setGroupId(subject.group_id);

                feature = _FeatureManager["default"].getFeature('equeoqd');

                if (subject.points) {
                  _EquizzerActions["default"].setUserPoints(subject.points);
                }

                if (!_config["default"].useDrupalContent) {
                  _context.next = 12;
                  break;
                }

                _context.t1 = "Bearer ";
                _context.next = 8;
                return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

              case 8:
                _context.t2 = _context.sent;
                _context.t0 = _context.t1.concat.call(_context.t1, _context.t2);
                _context.next = 13;
                break;

              case 12:
                _context.t0 = feature && feature.additionalData && feature.additionalData._auth ? feature.additionalData._auth : null;

              case 13:
                userAuth = _context.t0;

                if (!userAuth) {
                  _context.next = 51;
                  break;
                }

                user = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER);

                if (user && user.nickname) {
                  // TODO onMessageForThisApp is not defined here -> use it with props
                  (0, _QDGroupService.register)(this.onMessageForThisApp, subject.group_id, user.nickname);
                  this.props.setAblyAsRegistered(subject.group_id);
                }

                _context.next = 19;
                return _EquizzerActions["default"].setGroupId(subject.group_id);

              case 19:
                _context.next = 21;
                return _UserService["default"].getAllUsersAndLoadTheme(subject.group_id, userAuth);

              case 21:
                groupUsers = _context.sent;
                storedImages = this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH];
                _context.next = 25;
                return _UserService["default"].getUserImages(groupUsers, this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS], userAuth, storedImages);

              case 25:
                groupUsersWithImage = _context.sent;
                console.log('groupUsersWithImage', groupUsersWithImage);

                _EquizzerActions["default"].setGroupUsers(groupUsersWithImage);

                loadedUser = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER);
                opponents = [];
                groupUsersWithImage.forEach(function (groupUser) {
                  if (loadedUser && groupUser && groupUser.id === loadedUser.id) {
                    loadedUser.picture = groupUser.picture;

                    _EquizzerActions["default"].setUser(loadedUser, 'QuizSubjects');

                    _EquizzerActions["default"].setUserPoints(groupUser.points);
                  } else {
                    opponents.push(groupUser);
                  }
                });

                _EquizzerActions["default"].setOpponentsList(opponents);

                _context.next = 34;
                return _GameService["default"].loadAllGame(userAuth);

              case 34:
                allGamesUnfiltered = _context.sent;
                _context.next = 37;
                return _GameService["default"].loadLastGameWithEachOpponent(loadedUser, allGamesUnfiltered);

              case 37:
                allGame = _context.sent;
                _context.next = 40;
                return _EquizzerActions["default"].setAllGame(allGame);

              case 40:
                _context.next = 42;
                return _GameService["default"].loadHistoryBasedFeedback(userAuth);

              case 42:
                historyBasedFeedback = _context.sent;

                _EquizzerActions["default"].setHistoryBasedFeedback(historyBasedFeedback);

                completedGameIds = _GameService["default"].getCompletedGameIds(allGame);

                _EquizzerActions["default"].updateCompletedGameIds(completedGameIds);

                _context.next = 48;
                return _GameService["default"].getAllExpiredGames(allGamesUnfiltered);

              case 48:
                expiredGameIds = _context.sent;

                _EquizzerActions["default"].updateExpiredGameIds(expiredGameIds);

                this.props.changePageToQuizHome();

              case 51:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setSubject(_x) {
        return _setSubject.apply(this, arguments);
      }

      return setSubject;
    }()
  }, {
    key: "renderSubjectButton",
    value: function renderSubjectButton(subject, index) {
      var _this2 = this;

      // const learningState = this.state.data[DATA_STORE_PATHS.QD_LEARNING_STATE]
      // if (!learningState) {
      //   return null
      // }
      // const categoryState = learningState[subject.name]
      // if (!categoryState) {
      //   return null
      // }
      // const icon = categoryState.icon
      //   ? (
      //     <img
      //       className={ownStyles.categoryIcon}
      //       src={categoryState.icon}
      //       onError={(ev) => {
      //         ev.target.height = '0px'
      //         ev.target.width = '0px'
      //       }}
      //     />
      //   )
      //   : null
      //
      // const hideFeedback = DataStore.getElementByPathImmediately(DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK)
      // const learned = hideFeedback ? 0 : (categoryState.learned || 0)
      // const inProgress = categoryState.inProgess || 0
      // const untouched = 1.0 - learned - inProgress
      //
      // const learningProgressPie = (
      //   <div className={ownStyles.learningProgressPie}>
      //     <SimplePieChart
      //       borderWidth={2}
      //       borderColor='white'
      //       slices={[
      //         {
      //           color: this.state.categoryinfos && this.state.categoryinfos.untouched ? this.state.categoryinfos.untouched : 'transparent',
      //           value: untouched
      //         },
      //         {
      //           color: this.state.categoryinfos && this.state.categoryinfos.touched ? this.state.categoryinfos.touched : 'transparent',
      //           value: inProgress
      //         },
      //         {
      //           color: this.state.categoryinfos && this.state.categoryinfos.learned ? this.state.categoryinfos.learned : 'transparent',
      //           value: learned
      //         }
      //       ]}
      //     />
      //   </div>
      // )
      // const descriptionButton = categoryState.description
      //   ? (
      //     <div
      //       className={ownStyles.descriptionButton}
      //       onClick={() => showCategoryDescription(this.state.data[DATA_STORE_PATHS.QD_LEARNING_STATE], subject, true, true)}
      //     >
      //       <img alt="category info" src={require('./assets/info.svg')} style={{height: 30}} />
      //     </div>
      //   )
      //   : null
      //
      // const questionCount = categoryState.questionCount
      //   ? <span className={ownStyles.questionCount}>{categoryState.questionCount} Fragen</span>
      //   : null
      // return (
      //   <div className={ownStyles.categoriesFrame}>
      //     <Button
      //       key={`category_${subject.name}`}
      //       className={`${ownStyles.buttonParticipants} ${icon ? ownStyles.withIcon : ''} button button-ergo`}
      //       theme={target.categoryTheme ? target.categoryTheme : null}
      //       onClick={() => this.setCategory(subject)}
      //     >
      //       {icon}
      //       <div className={ownStyles.categoryName} dangerouslySetInnerHTML={{__html: subject.name}}/>
      //       <div className={ownStyles.bottomInfo}>
      //         {this.props.hideLearningState ? null : learningProgressPie}
      //         {questionCount}
      //       </div>
      //     </Button>
      //     {descriptionButton}
      //   </div>
      // )
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizSubjects["default"].categoriesFrame
      }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
        key: "category_".concat(subject.name),
        className: "".concat(_QuizSubjects["default"].buttonParticipants, " button button-ergo"),
        onClick: function onClick() {
          return _this2.setSubject(subject);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizSubjects["default"].categoryName,
        dangerouslySetInnerHTML: {
          __html: subject.name
        }
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (!this.state.data[_DataStore.DATA_STORE_PATHS.QD_SUBJECTS] || this.state.data[_DataStore.DATA_STORE_PATHS.QD_SUBJECTS].length === 0) {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      }

      console.log('stateSubjects:', this.state.data[_DataStore.DATA_STORE_PATHS.QD_SUBJECTS]);

      var subjectButtons = this.state.data[_DataStore.DATA_STORE_PATHS.QD_SUBJECTS].map(function (subject, index) {
        return _this3.renderSubjectButton(subject, index);
      });

      var backButton = this.props.runsInKesi ? /*#__PURE__*/_react["default"].createElement("span", {
        className: _Quiz["default"].backButton,
        style: {
          backgroundColor: _cssConstants["default"].colors.buttonBackgroundColor
        },
        onClick: this.props.onBack
      }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowLeft["default"], {
        style: {
          fontSize: '30px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _Quiz["default"].backText
      }, (0, _QuizStrings.getString)('BACK'))) : null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _Quiz["default"].contentHome
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Quiz["default"].innerHeader
      }, backButton), /*#__PURE__*/_react["default"].createElement("div", {
        id: "scrollElement",
        className: _Quiz["default"].innerContentScroll,
        style: {
          height: '92%'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "innerContent",
        style: {
          height: '100%'
        }
      }, subjectButtons)));
    }
  }]);
  return QuizSubjects;
}(_DataStoreComponent2["default"]);

exports["default"] = QuizSubjects;
QuizSubjects.propTypes = {
  onBack: _propTypes["default"].func,
  setTitle: _propTypes["default"].func,
  getAuthToken: _propTypes["default"].func.isRequired,
  tournamentMode: _propTypes["default"].bool,
  runsInKesi: _propTypes["default"].bool,
  trainingMode: _propTypes["default"].bool,
  hideLearningState: _propTypes["default"].bool,
  changePageToQuizHome: _propTypes["default"].func,
  setAblyAsRegistered: _propTypes["default"].func.isRequired
};